import { render } from "./FoldersList.vue?vue&type=template&id=743ee54c&scoped=true"
import script from "./FoldersList.vue?vue&type=script&lang=js"
export * from "./FoldersList.vue?vue&type=script&lang=js"

import "./FoldersList.vue?vue&type=style&index=0&id=743ee54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743ee54c"]])

export default __exports__